import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Ortak bileşenler
import AppBar from "./components/AppBar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

// Genel sayfalar
import Home from "./pages/Anasayfa/home";
import About from "./pages/Hakkimizda/about";
import Iletisim from "./pages/Iletisim/Iletisim";

//Yatırım Sayfaları
import Yatirim from "./pages/Yatirim/Yatirim";
import Sorulan_Sorular from "./pages/Yatirim/Sorular_Sorular/Sorulan_Sorular";

// Kurumsal Panel Sayfaları
import CorporateSignup from "./pages/Corporate/CorporateSignUp/CorporateSignup";
import CorporateLogin from "./pages/Corporate/CorporateLogin/CorporateLogin";
import CorporateForgotPassword from "./pages/Corporate/CorporateForgotPassword/CorporateForgotPassword";
import CorporateDashboard from "./pages/Corporate/CorporateDashboard/Dashboard/CorporateDashboard";
import AddProject from "./pages/Corporate/CorporateDashboard/Widget/AddProject/AddProject";
import CompanyProjects from "./pages/Corporate/CorporateDashboard/Widget/CompanyProjects/CompanyProjects";
import CompanyProjectsDetails from "./pages/Corporate/CorporateDashboard/Widget/UpdateProject/CompanyProjectsDetails";
import CorporateUpdatePassword from "./pages/Corporate/CorporateDashboard/Widget/UpdatePassword/CorporateUpdatePassword";
import CorporateUpdateLogo from "./pages/Corporate/CorporateDashboard/Widget/UpdateLogo/CorporateUpdateLogo";
import ProtectedCorporateRoute from "./pages/Corporate/ProtectedCorporateRoute/ProtectedCorporateRoute";

// Diğer sayfalar
import OdulSistemi from "./Widgets/OdulSistemi/OdulSistemi";
import SSS from "./pages/SSS/SSS";

// Haber Sayfaları
import Haberler from "./pages/Haberler/tum_haberler";
import HaberDetay from "./pages/Haberler/Haber_detay/haber_detay_sayfasi";

// Makale Sayfaları
import Articles from "./pages/Makaleler/tüm_makaleler";
import MakaleDetay from "./pages/Makaleler/Makale_detay/makale_detay";

// Şehir filtreleme sayfaları
import IzmirBox from "./pages/Anasayfa/components/CitiesBox/IzmirBox";
import AnkaraBox from "./pages/Anasayfa/components/CitiesBox/AnkaraBox";
import IstanbulBox from "./pages/Anasayfa/components/CitiesBox/IstanbulBox";

// Proje sayfaları
import AllProjects from "./Widgets/AllProjects/AllProjects";
import ProductPage from "./components/ProductPage/ProductPage";

//Kanunlar
import Yasal_Uyari from "./pages/Kanunlar/Yasal_Uyari/Yasal_Uyari";
import Kullanim_Kosullari from "./pages/Kanunlar/Kullanim_Kosullari/Kullanim_Kosullari";
import Aydinlatma_Metni from "./pages/Kanunlar/Aydinlatma_Metni/Aydinlatma_Metni";
import Cerez_Politikasi from "./pages/Kanunlar/Cerez_Politikasi/Cerez_Politikası";
import Uyelik_Sozlesmesi from "./pages/Kanunlar/Uyelik_Sozlesmesi/Uyelik_Sozlesmesi";
import Ilan_Yayinlama_Kurallari from "./pages/Kanunlar/Ilan_Yayinlama_Kurallari/Ilan_Yayinlama_Kurallari";
import KVKK_Basvuru_Formu from "./pages/Kanunlar/KVKK_Basvuru_Formu/KVKK_Basvuru_Formu";
import Ilan_Yayinlarken_Dikkat_Edilmesi_Gerekenler from "./pages/Kanunlar/Ilan_Yayinlarken_Dikkat_Edilmesi_Gerekenler/Ilan_Yayinlarken_Dikkat_Edilmesi_Gerekenler";
import PaymentPage from "./pages/Corporate/CorporateDashboard/Widget/Pay/Payment";

//Mobil Uygulama Sözleşmeleri
import Mobil_Uygulama_Kullanim_Sozlesmesi from "./pages/Kanunlar/Mobil/Kullanici_Uyelik_Sozlesmesi/kullanici_uyelik_sozlesmesi";
import Mobil_uygulama_aydinlatma_metni from "./pages/Kanunlar/Mobil/Aydinlatma_Metni/aydinlatma_metni";
import Ticari_iletisim_aydinlatma_metni from "./pages/Kanunlar/Mobil/Pazarlama_Aydinlatma_Metni/pazarlama_aydinlatma_metni";
import Ticari_elektronik_ileti_onayi from "./pages/Kanunlar/Mobil/Acik_Riza_Metni/acik_riza_metni";


function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppBar />

      <Routes>
        {/* Genel sayfalar */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/iletisim" element={<Iletisim />} />

        <Route path="/yatirim" element={<Yatirim />} />
        <Route path="/sorulan_sorular" element={<Sorulan_Sorular />} />

        {/* Kurumsal panel */}
        <Route path="/signup_corporate" element={<CorporateSignup />} />
        <Route path="/login_corporate" element={<CorporateLogin />} />
        <Route path="/forgot_password_corporate" element={<CorporateForgotPassword />} />

        <Route
          path="/dashboard_corporate"
          element={
            <ProtectedCorporateRoute>
              <CorporateDashboard />
            </ProtectedCorporateRoute>
          }
        />

        <Route
          path="/add-project"
          element={
            <ProtectedCorporateRoute>
              <AddProject />
            </ProtectedCorporateRoute>
          }
        />

        <Route
          path="/company_projects"
          element={
            <ProtectedCorporateRoute>
              <CompanyProjects />
            </ProtectedCorporateRoute>
          }
        />

        <Route
          path="/company_project_details"
          element={
            <ProtectedCorporateRoute>
              <CompanyProjectsDetails />
            </ProtectedCorporateRoute>
          }
        />

        <Route
          path="/company_update_password"
          element={
            <ProtectedCorporateRoute>
              <CorporateUpdatePassword />
            </ProtectedCorporateRoute>
          }
        />

        <Route
          path="/company_update_logo"
          element={
            <ProtectedCorporateRoute>
              <CorporateUpdateLogo />
            </ProtectedCorporateRoute>
          }
        />

        <Route
          path="/ilan_yayinlarken_dikkat_edilmesi_gerekenler"
          element={
            <ProtectedCorporateRoute>
              <Ilan_Yayinlarken_Dikkat_Edilmesi_Gerekenler />
            </ProtectedCorporateRoute>
          }
        />

        <Route
          path="/payment"
          element={
            <ProtectedCorporateRoute>
              <PaymentPage />
            </ProtectedCorporateRoute>
          }
        />

        {/* Haber Sayfaları */}
        <Route path="/haberler" element={<Haberler />} />
        <Route path="/haber/:id" element={<HaberDetay />} />

        {/* Makale Sayfaları */}
        <Route path="/articles" element={<Articles />} />
        <Route path="/article/:id" element={<MakaleDetay />} />

        {/* Diğer sayfalar */}
        <Route path="/sss" element={<SSS />} />
        
        <Route path="/odul_sistemi" element={<OdulSistemi />} />

        {/* Şehir bazlı filtreleme sayfaları */}
        <Route path="/city/izmir" element={<IzmirBox />} />
        <Route path="/city/ankara" element={<AnkaraBox />} />
        <Route path="/city/istanbul" element={<IstanbulBox />} />

        {/* Proje sayfaları */}
        <Route path="/projects" element={<AllProjects />} />
        <Route path="/projects/all" element={<AllProjects />} />
        <Route path="/project/:id" element={<ProductPage />} />

        {/* Web Sözleşmeleri */}
        <Route path="/yasal_uyari" element={<Yasal_Uyari />} />
        <Route path="/kullanim_kosullari" element={<Kullanim_Kosullari />} />
        <Route path="/aydinlatma_metni" element={<Aydinlatma_Metni />} />
        <Route path="/cerez_politikasi" element={<Cerez_Politikasi />} />
        <Route path="/uyelik_sozlesmesi" element={<Uyelik_Sozlesmesi />} />
        <Route path="/ilan_yayinlama_kurallari" element={<Ilan_Yayinlama_Kurallari />} />
        <Route path="/kvkk_basvuru_formu" element={<KVKK_Basvuru_Formu />} />

        {/* Mobil Uygulama Sözleşmeleri */}
        <Route path="/mobil_uygulama_kullanici_uyelik_sozlesmesi" element={<Mobil_Uygulama_Kullanim_Sozlesmesi />} />
        <Route path="/mobil_uygulama_aydinlatma_metni" element={<Mobil_uygulama_aydinlatma_metni />} />
        <Route path="/mobil_uygulama_ticari_iletisim_aydinlatma_metni" element={<Ticari_iletisim_aydinlatma_metni />} />
        <Route path="/mobil_uygulama_ticari_elektronik_ileti_onayi" element={<Ticari_elektronik_ileti_onayi />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
